import React, { useState, useContext, useEffect, useReducer } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Formik } from "formik";
import * as Yup from "yup";
import "../../site.css";
import { AuthContext } from "../../AuthContext";
import { NavLink } from "react-router-dom";
import { getAPI } from '../GdacsAPI';

const ChangePwd = (props) => {
    const authContext = useContext(AuthContext);
    const initState = { enabledToSave: false, isModified: false };
    const [responseMessage, setResponseMessage] = React.useState("");
    const initDataObject = { username: authContext.username, oldpassword: "", newPassword: "", cNewPassword: "" }
    const [user, setUser] = React.useState(initDataObject);
    const [isModified, setIsModified] = React.useState(false);
    const [alert, setAlert] = useState(false);
    const [isChanged, setIsChanged] = React.useState(false);
    const [isClosed, setIsClosed] = React.useState(false);
    const [show, setShow] = React.useState(false);

    const checkValidation = Yup.object().shape({
        username: Yup.string().required("Required"),
        oldpassword: Yup.string().required("No password provided."),
        newPassword: Yup.string().required("No password provided.").min(8, "Password is too short - should be 8 chars minimum.").matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@_#.\$%\^&\*\~\.\-])(?=.{8,})/,
            "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character (!@_#$%.-&* ~)."
        ),
        confirm_password: Yup.string().required("No password provided.").min(8, "Password is too short - should be 8 chars minimum.").matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@_#.\$%\^&\*\~\.\-])(?=.{8,})/,
            "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character (!@_#$%.-&* ~)."
        ).oneOf([Yup.ref("newPassword")], "Password's not match")
    })
    const [data, setData] = React.useState(initDataObject);

    const handleClose = () => {
        setShow(false);
        setIsChanged(undefined);
        /*        authContext.logout();*/
        setIsClosed(true);
    }

    //if (isClosed) {
    //    /*        handleLogout();*/
    //    return <Redirect to={"/"} />
    //}

    const handleSubmit = async e => {
        e.preventDefault();
    }

    async function ChangePassword(values) {
        let json = {
            username: values.username,
            oldPassword: values.oldpassword,
            newPassword: values.newPassword,
            confirmPassword: values.confirm_password
        }

        const settings = {
            method: 'POST',
            body: JSON.stringify(json),
            headers: {
                'Authorization': 'Bearer ' + authContext.token,
                Accept: 'application/json',
                'Content-Type': 'application/json',
            }
        };

        const response = await fetch(getAPI() + `api/register/Users/changepassword/`, settings);
        if (!response.ok) {
            const resp = await response.json();
            setResponseMessage(resp.message);
            return;
        }
        else {
            //setResponseMessage("Your Password have been changed.");
            setIsModified(false);
            setShow(true);
        }

    }

    const handleFormikSubmit = (values, { setSubmitting }) => {
        setSubmitting(false);
        ChangePassword(values);
    }

    return (
        <Formik
            initialValues={initDataObject}
            validationSchema={checkValidation}
            onSubmit={handleFormikSubmit}
        >
            {({
                values,
                touched,
                errors,
                handleChange,
                handleBlur,
                handleSubmit
            }) => (
                <div className="alerts_container col-12">
                    <form>
                        <br />
                        <h4 className="d-flex justify-content-center hr-title">Change your Password</h4>
                        <br />
                        <div className="p_summary">Password: minimum 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character (!@_#$%.-&* ~).</div>
                        <br />
                        <div>
                            <label className="label-user" htmlFor="username">Username</label>
                            <input className="form-control form-control-sm"
                                name="username"
                                type="text"
                                placeholder="Enter your Username"
                                value={values.username} onChange={handleChange} />
                            {/*                                className={errors.username && touched.username && "error"}*/}
                            {errors.email && touched.username && (
                                <div className="input-feedback">{errors.username}</div>
                            )}
                        </div>
                        <div>
                            <label className="label-user" htmlFor="oldpassword">Old Password</label>
                            <input className="form-control form-control-sm"
                                name="oldpassword"
                                type="password"
                                placeholder="Enter old password"
                                value={values.oldpassword}
                                onChange={handleChange}
                            />
                            {errors.oldpassword && touched.oldpassword && (
                                <div className="input-feedback">{errors.oldpassword}</div>
                            )}
                        </div>
                        <div>
                            <label className="label-user" htmlFor="newPassword">New Password</label>
                            <input className="form-control form-control-sm"
                                name="newPassword"
                                type="password"
                                placeholder="Enter new password"
                                value={values.newPassword}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            {errors.newPassword && touched.newPassword && (
                                <div className="input-feedback">{errors.newPassword}</div>
                            )}
                        </div>
                        <div>
                            <label className="label-user">Confirm Password</label>
                            <input className="form-control form-control-sm"
                                type="password"
                                name="confirm_password"
                                placeholder="Confirm new password"
                                value={values.confirm_password}
                                onChange={handleChange}
                                onBlur={ handleBlur}
                            />
                            {errors.confirm_password && touched.confirm_password && (
                                <div className="input-feedback">{errors.confirm_password}</div>
                            )}
                        </div>
                        {responseMessage &&
                            <div className="input-feedback">{responseMessage}</div>
                        }
                        <br />
                        <div style={{ paddingRight: "20px" }}>
                            <Button className="float-right btn btn-primary" variant="primary" onClick={handleSubmit}>
                                Save
                            </Button>
                        </div>
                        <br />
                        <br />
                        <Modal show={show} onHide={handleClose}>
                            <Modal.Header closeButton>
                                <Modal.Title>Change Password</Modal.Title>
                            </Modal.Header>
                            <><Modal.Body>Your Password has been changed.</Modal.Body>
                                <Modal.Footer>
                                    <NavLink
                                        to={{
                                            pathname: '/Home',
                                            origin: "ChangePwd",
                                        }}
                                        className="btn btn-primary " >
                                        Ok
                                    </NavLink>
                                </Modal.Footer></>
                        </Modal>
                        <br />
                        <br />
                        {alert && <h2> Submit Successful</h2>}
                    </form>
                </div>
            )}
        </Formik>
    );
}

export { ChangePwd };